import React from 'react'
import { MerchantLocationsLoader, LoaderSwitcher } from 'router/Loaders'
import Customers from 'components/Customers'

export const CustomersWrapper = () => {
  return (
    <MerchantLocationsLoader>
      {(isParentLoaded) => (
        <LoaderSwitcher isParentLoaded={isParentLoaded}>
          <Customers />
        </LoaderSwitcher>
      )}
    </MerchantLocationsLoader>
  )
}
